import { Injectable } from '@angular/core';

/**
 * Reference-counted scroll lock service.
 * Multiple consumers can lock/unlock independently without
 * clobbering each other's state.
 */
@Injectable({ providedIn: 'root' })
export class ScrollLockService {
  private lockCount = 0;
  private originalPadding: string = '';

  lock(): void {
    this.lockCount++;
    if (this.lockCount === 1) {
      // Calculate scrollbar width to prevent layout shift
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      
      this.originalPadding = document.body.style.paddingRight;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `calc(${this.originalPadding || '0px'} + ${scrollbarWidth}px)`;
      }
      
      document.body.style.overflow = 'hidden';
    }
  }

  unlock(): void {
    this.lockCount = Math.max(0, this.lockCount - 1);
    if (this.lockCount === 0) {
      document.body.style.overflow = '';
      document.body.style.paddingRight = this.originalPadding;
    }
  }

  /** Force-reset (e.g. from ngOnDestroy safety net) */
  forceUnlock(): void {
    this.lockCount = 0;
    document.body.style.overflow = '';
    document.body.style.paddingRight = this.originalPadding;
  }
}
